import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Header from './components/Header.vue';
import VModal from 'vue-js-modal'
import VueCookies from 'vue-cookies'
import Slick from 'vue-slick'
import VueConfirmDialog from 'vue-confirm-dialog'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

Vue.config.productionTip = false

//ajax通信のグローバル設定
axios.create({
    auth: {
        username: 'admin',
        password: 'vis'
    }
})
axios.defaults.withCredentials = true

Vue.use(VueAxios, axios)
Vue.use(Loading)
Vue.use(VModal)
Vue.use(VueCookies)
Vue.use(Slick)
Vue.use(VueConfirmDialog)

//共通ファイル
Vue.component('Header', Header)
Vue.component('slick', Slick)
Vue.component('vueDropzone', vue2Dropzone)

require('@/assets/scss/style.scss')

const hostName = process.env.VUE_APP_BASE_URL // .env.

Vue.RequestURI = Vue.prototype.RequestURI = hostName + 'ajax.cgi'//各自開発用のIPを入力
Vue.UploadURI = Vue.prototype.UploadURI = hostName + 'upload.cgi'//各自開発用のIPを入力

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
